import stripe from 'stripe'
import { Column, Entity } from 'typeorm'
import { UserModifiableEntity } from '../entity'

@Entity()
export class BillingProfile extends UserModifiableEntity<BillingProfile> {
	@Column({
		type: 'text',
		nullable: false,
	})
	stripeAccountId: string

	@Column({
		type: 'json',
		nullable: true,
	})
	profile?: stripe.Account
}
